<template>
  <div>
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div
          v-show="actor.privilege <= 3"
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
        >
          <label class="text-sm opacity-75">Branch</label>
          <v-select
            :disabled="actor.privilege >= 3"
            :options="branchList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.branch"
            class="mb-4 md:mb-0"
          />
        </div>
        <div v-if="actor.privilege < 6" class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Owner (Username)</label>
          <v-select
            @search="searchOwner"
            :options="ownerFilterList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.owner"
          />
        </div>
        <div v-else class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-input
            disabled
            label="Owner"
            class="w-full"
            :value="actor.username"
          />
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="mt-5">
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th>No</th>
                <th>Notification</th>
                <th>Active</th>
              </tr>
            </thead>
            <tbody v-if="loading">
              <tr>
                <td colspan="99" class="text-center">Loading....</td>
              </tr>
            </tbody>

            <tbody v-else-if="data.length > 0">
              <tr v-for="(item, index) in data" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.code }}</td>
                <td class="text-center">
                  <vs-switch
                    v-model="item.is_active"
                    @click="set_active(index)"
                  >
                    <span slot="active">Ative</span>
                    <span slot="inactive">Inactive</span>
                  </vs-switch>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="99" class="text-center">No Data Available</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },

  data() {
    return {
      data: [],
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',
      actor: {},

      loading: false,
      tempId: 0,

      listUserNotif: [],

      ownerList: [],
      branchList: [],
      ownerFilterList: [],

      filter: {
        branch: '',
        owner: ''
      },

      timer: null,
      notify: 'Server Error'
    }
  },

  computed: {
    filterBranch() {
      return this.filter.branch ? this.filter.branch.value : ''
    },

    filterOwner() {
      return this.filter.owner ? this.filter.owner.value : ''
    }
  },

  watch: {
    // filter: {
    //   handler(val) {},
    //   deep: true
    // },

    filterBranch() {
      this.filter.owner = ''
    },

    filterOwner() {
      this.initTable()
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.getBranchList()
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    getBranchList() {
      this.$http
        .get(`${this.$api.endpoint}/branch/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.branchList = res.data.message.data

          this.filter.branch = this.branchList.find((item) => {
            return item.value === this.actor.branch
          })

          if (this.actor.privilege >= 4) {
            this.searchOwner(this.actor.username)
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    searchOwner(search) {
      if (this.actor.privilege == 2 && !this.filter.branch) {
        this.filter.owner = ''
        return
      }

      if (search.length >= 3) {
        this.$http
          .get(`${this.$api.endpoint}/user/owner`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            params: {
              branch:
                this.actor.privilege >= 4
                  ? this.actor.branch_id
                  : this.filter.branch
                  ? this.filter.branch.value
                  : '',
              search: search
            }
          })
          .then((res) => {
            this.ownerFilterList = res.data.message.data

            if (this.actor.privilege >= 4) {
              this.filter.owner = this.ownerFilterList.find((item) => {
                return item.value === this.actor.id
              })

              this.initTable()
            }
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      } else {
        this.ownerFilterList = []
      }
    },

    initTable() {
      if (
        !this.filter.owner ||
        (!this.filter.branch && this.actor.privilege > 1)
      ) {
        this.data = []
        return
      }

      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/user_notif/datatable`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },

          params: {
            user_id: this.filter.owner ? this.filter.owner.value : ''
          }
        })
        .then((res) => {
          this.data = res.data.message.data

          // this.getListUserNotif()

          this.loading = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    set_active(index) {
      let dataEdit = this.data[index]

      let user_id = this.filter.owner.value
      let old_is_active = dataEdit.is_active
      let new_is_active = !old_is_active ? true : false

      let url = `${this.$api.endpoint}/user_notif/set_active/${user_id}`

      this.$http
        .post(
          url,
          {
            is_active: new_is_active,
            alert_no: dataEdit.alert_no,
            code: dataEdit.code
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.notify = res.data.message.split('_').join(' ')
          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>
